<template>
  <div class="admin">
    <div class="right-panel">
      <div class="right-container">
          <div class="rp-header">
            <div>{{statusFilter.name}}</div>
            <div class="header-right">
              <button
                class="admin-btn"
                @click="addUser"
                v-if="statusFilter.key=='manage'"
                style="width: 130px"
              >ADD APPROVER</button>
              <button
                class="admin-btn"
                :disabled="bulkIds.length == 0"
                @click="editBulk"
                v-if="statusFilter.key=='assign'"
              >
                <span>BULK EDIT</span>
              </button>
            </div>
          </div>
          <data-table
            :headings="headings"
            :rows="tableData"
            :search-query="searchQuery"
            :perPage="rowCount"
            :page="pageNumber"
          >
            <template v-slot:tickBoxSlot="slotProps">
              <label class="container">
                <input
                  type="checkbox"
                  :id="slotProps.row.customer_id"
                  :value="slotProps.row.customer_id"
                  v-model="bulkIds"
                  class="tick-box"
                />
                <span class="checkmark"></span>
              </label>
            </template>
            <template v-slot:actionsSlot="slotProps">
              <button class="edit-btn" @click="edit(slotProps.row)">EDIT</button>
              <button :disabled="bulkIds.length != 0" v-if="statusFilter.key == 'assign'" class="delete-btn" @click="deleteCustomer(slotProps.row)">DELETE</button>
              <button
                v-if="statusFilter.key=='manage'"
                class="delete-btn"
                @click="deleteModal(slotProps.row)"
                :disabled="id == slotProps.row.id"
              >DELETE</button>
            </template>
          </data-table>
        <div class="arrows" v-if="pageCount > 1">
          <img
            class="arrow-icon"
            @click="prevPage"
            style="margin-right:40px"
            src="../../src/assets/images/icons/0828-chevron-left.svg"
          />
          <img
            class="arrow-icon"
            @click="nextPage"
            src="../../src/assets/images/icons/0829-chevron-right.svg"
          />
        </div>
      </div>
    </div>
    <modal class="modal-bg" v-show="isModalOpen">
      <template v-slot:header>
        <div>{{modalHeader}}</div>
      </template>
      <template v-slot:body>
        <div class="app-modal" v-if="modalType == 'add'">
          <input v-model="newName" placeholder="Enter approver name" style="margin-bottom: 20px;" />
          <input v-model="newEmail" type="email" placeholder="Enter approver email" />
        </div>
        <div class="app-modal" v-else-if="modalType == 'edit'">
          <h3>Select a new approver for {{customerName}}</h3>
          <multiselect
            class="multiselect"
            v-model="editApprover"
            :options="users"
            track-by="name"
            label="name"
            placeholder="Select approver"
            :searchable="true"
            :show-label="false"
            :allow-empty="false">
            <template slot="noResult">No results found.</template>
          </multiselect>
        </div>
        <div class="app-modal" v-else-if="modalType == 'bulkEdit'">
          <h3>Select a new approver for the selected customers</h3>
          <multiselect
            class="multiselect"
            v-model="editApprover"
            :options="users"
            track-by="name"
            label="name"
            placeholder="Select approver"
            :searchable="true"
            :show-label="false"
            :allow-empty="false">
            <template slot="noResult">No results found.</template>
          </multiselect>
        </div>
        <div class="app-modal" v-else-if="modalType == 'editAccount'">
          <h3>Update info for {{approverName}}</h3>
          <input v-model="newName" placeholder="Enter approver name" style="margin-bottom: 20px;" />
          <input v-model="newEmail" placeholder="Enter approver email"/>
        </div>
        <div class="app-modal" v-else-if="modalType == 'deleteAccount'">
          <h3>Would you like to delete this user?</h3>
        </div>
        <div class="app-modal" v-else-if="modalType == 'deleteCustomer'">
          <h3>Would you like to delete this customer?</h3>
        </div>
      </template>
      <template v-slot:footer>
        <button v-if="modalType=='editAccount'" :disabled="!newName || !newEmail" @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button v-else-if="modalType=='add'" :disabled="!newName || !newEmail" @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button v-else-if="modalType=='edit' || modalType =='bulkEdit'" :disabled="!editApprover || disableConfirm" @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button v-else @click="commit" style="margin-right: 13px;">CONFIRM</button>
        <button @click="closeModal">CANCEL</button>
      </template>
    </modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DataTable from "@/components/DataTable.vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Modal from "@/components/Modal.vue";
import {
  GET_ASSOCIATED_APPROVERS,
  GET_ALL_USERS,
  UPDATE_CUSTOMER_APPROVER,
  ADD_USER,
  EDIT_USER,
  DELETE_USER,
  DELETE_CUSTOMER,
  LOGOUT
} from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "admin",
  components: {
    DataTable,
    Multiselect,
    Modal
  },
  props: {
    statusFilter: Object,
    searchQuery: String
  },
  data() {
    return {
      sortField: null,
      tableData: [],
      isModalOpen: false,
      modalHeader: "",
      newEmail: "",
      newName: "",
      modalType: "",
      editApprover: "",
      error: "",
      pageNumber: 1,
      rowCount: 50,
      editApprovers: [],
      bulkIds: [],
      customerName: "",
      customerId: [],
      approverName: "",
      userEmail: "",
      disableConfirm: false,
      approverId: "",
      approverEmail: ""
    };
  },
  methods: {
    addUser() {
      this.modalType = "add";
      this.isModalOpen = true;
      this.modalHeader = "Add approver";
    },
    edit(row) {
      if (this.statusFilter.key == "manage") {
        this.modalType = "editAccount";
        this.approverName = row.name;
        this.approverId = row.id;
        this.approverEmail = row.email;
        } else {
        this.modalType = "edit";
        this.customerName = row.customer_name;
        this.customerId = [row.customer_id];
      }
      this.isModalOpen = true;
      this.modalHeader = "Edit approver";
    },
    deleteCustomer(row) {
      if(this.statusFilter.key == "assign"){
        this.modalType = "deleteCustomer";
        this.modalHeader = "Delete customer";
        this.approverName = row.customer_name;
        this.customerId = row.customer_id;
        this.isModalOpen = true;
      }
    },
    editBulk() {
      this.modalType = "bulkEdit";
      this.modalHeader = "Edit approver";
      this.isModalOpen = true;
      this.bulkIds = this.bulkIds.map(String);
      this.customerId = this.bulkIds;
    },
    deleteModal(row) {
      this.modalType = "deleteAccount";
      this.modalHeader = "Delete Account";
      this.userEmail = row.email;
      this.isModalOpen = true;
    },
    closeModal() {
      this.newEmail = "";
      this.newName = "";
      this.editApprover = "";
      this.isModalOpen = false;
    },
    commit() {
      if (this.modalType === "edit" || this.modalType === "bulkEdit") {
        this.commitCustomerApprovers();
      } else if (this.modalType === "add") {
        if(!this.validEmail(this.newEmail)){
          this.$notify({
            text: "Valid email required",
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
        }
        else { 
        this.commitUser();
          }
        }
         else if (this.modalType === "editAccount") {
        if(!this.validEmail(this.newEmail)){
             this.$notify({
            text: "Valid email required",
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
          }
          else{
        this.manageApprovers();
          }
      } else if (this.modalType == "deleteAccount") {
        this.deleteUser();
      } 
      else if (this.modalType == "deleteCustomer") {
        this.removeCustomer();
      }
      else {
        this.closeModal();
      }
    },
    commitCustomerApprovers() {
      this.disableConfirm = true;
      this.$store
        .dispatch(UPDATE_CUSTOMER_APPROVER, {
          customerId: this.customerId,
          userId: this.editApprover.id
        })
        .then(() => {
          this.$notify({
            text: "Customer Approver Updated",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.isModalOpen = false;
          this.editApprover = "";
          this.customerId = "";
          this.bulkIds = [];
          this.getAssociatedApprovers();
          this.disableConfirm = false;
        })
        .catch(err => {
          this.$notify({
            text: err,
            classes: "vue-notification",
            position: "top center",
            type: "error"
          });
          this.error = err;
          this.disableConfirm = false;
        });

    },
    commitUser() {
      this.$store
        .dispatch(ADD_USER, {
          name: this.newName,
          email: this.newEmail
        })
        .then(() => {
          this.$notify({
            text: "Approver added",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.isModalOpen = false;
          this.newName = "";
          this.newEmail = "";
          if (this.statusFilter.key == "manage") {
            this.getAllUsers();
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 400) {
            this.$notify({
              text: "This email is already associated with a user.",
              classes: "vue-notification",
              position: "top center",
              type: "error"
            });
          }
          this.newName = "";
          this.newEmail = "";
          this.error = err;
        });
    },
    manageApprovers() {
      this.$store
        .dispatch(EDIT_USER, {
          name: this.newName,
          email: this.newEmail,
          user_id: this.approverId,
        })
        .then(() => {
          this.$notify({
            text: "User Edited",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });

          if(this.currentEmail == this.approverEmail){
            this.isModalOpen = false;
            this.logout();
            return;
          }
          
          this.isModalOpen = false;
          this.newName = "";
          this.newEmail = "";
          if (this.statusFilter.key == "manage") {
            this.getAllUsers();
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 400) {
            this.$notify({
              text: "This email is already associated with a user.",
              classes: "vue-notification",
              position: "top center",
              type: "error"
            });
          }
          this.newName = "";
          this.error = err;
        });
    },
    deleteUser() {
      this.$store
        .dispatch(DELETE_USER, {
          email: this.userEmail
        })
        .then(() => {
          this.$notify({
            text: "User Deleted",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.isModalOpen = false;
          this.pageNumber = 1;
          this.newName = "";
          this.newEmail = "";
          if (this.statusFilter.key == "manage") {
            this.getAllUsers();
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 400) {
            this.$notify({
              text: err,
              classes: "vue-notification",
              position: "top center",
              type: "error"
            });
          }
          this.newName = "";
          this.newEmail = "";
          this.error = err;
        });
    },
    removeCustomer() {
      this.$store
        .dispatch(DELETE_CUSTOMER, {
          customerId: this.customerId
        })
        .then(() => {
          this.$notify({
            text: "Customer Deleted",
            classes: "vue-notification",
            position: "top center",
            type: "success"
          });
          this.isModalOpen = false;
          this.pageNumber = 1;
          this.customerId = "";
          if (this.statusFilter.key == "assign") {
            this.getAssociatedApprovers();
          }
        })
        .catch(err => {
          console.log(err);
          if (err) {
            this.$notify({
              text: err,
              classes: "vue-notification",
              position: "top center",
              type: "error"
            });
          }
          this.isModalOpen = false;
          this.customerId = "";
          this.error = err;
        });
    },
    getAssociatedApprovers() {
      const loader = this.$loading.show();
      this.$store.dispatch(GET_ASSOCIATED_APPROVERS).finally(() => {
        if (this.statusFilter.key == "assign") {
          this.tableData = this.customersTableData;
        }
        loader.hide();
      });
    },
    getAllUsers() {
      const loader = this.$loading.show();
      this.$store.dispatch(GET_ALL_USERS).finally(() => {
        if (this.statusFilter.key == "manage") {
          this.tableData = this.users;
        }
        loader.hide();
      });
    },
    nextPage() {
      if (this.pageNumber < this.pageCount && this.pageNumber != this.pageCount)
        this.pageNumber++;
    },
    prevPage() {
      if (this.pageCount >= this.pageNumber && this.pageNumber !== 1)
        this.pageNumber--;
    },
    validEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.replace({ name: "login" });
      });
    }
  },
  watch: {
    statusFilter() {
      this.pageNumber = 1;
      if (this.statusFilter.key == "manage") {
        if (this.users.length == 0) {
          this.getAllUsers();
        } else {
          this.tableData = this.users;
        }
      } else if (this.statusFilter.key == "assign") {
        if (this.customersTableData.length == 0) {
          this.getAssociatedApprovers();
        } else {
          this.tableData = this.customersTableData;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      customers: ["customers"],
      users: ["users"]
    }),
    customersTableData() {
      var customersArray = []
      if(this.customers){
      for(let i = 0; i < this.customers.length; i++){
        if(this.customers[i].isActive == 1){
          customersArray.push(this.customers[i]);
        }
      }
      return customersArray;
      }
      return null;
    },
    headings() {
      if (this.statusFilter.key == "assign") {
        return [
          {
            label: "",
            key: "tickBox",
            sortable: false
          },
          {
            label: "Orderer",
            key: "customer_name"
          },
          {
            label: "Orderer email",
            key: "customer_email"
          },
          {
            label: "Approver",
            key: "approver_name"
          },
          {
            label: "Approver email",
            key: "approver_email"
          },
          {
            label: "Actions",
            key: "actions",
            sortable: false
          }
        ];
      } else {
        return [
          {
            label: "Approver",
            key: "name"
          },
          {
            label: "Approver email",
            key: "email"
          },
          {
            label: "Actions",
            key: "actions",
            sortable: false
          }
        ];
      }
    },
    currentEmail(){
      return this.$store.state.auth.user.email
    },
    pageCount() {
      let l = this.tableData.length,
        s = this.rowCount;
      return Math.ceil(l / s);
    },
    id() {
      return this.$store.state.auth.user.id;
    }
  },
  created() {
    this.getAllUsers();
    this.getAssociatedApprovers();
  }
}
</script>


<style lang="scss" scoped>
h3 {
  text-align: left;
}

.tick-box {
  height: 20px;
  width: 20px;
  margin: 0;
}

.admin {
  width: 100%;
  display: flex;
}

.user-icon {
  padding-left: 15px;
}

.right-panel {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.right-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: fixed;
  width: calc(100% - 400px);
  height: calc(100% - 84px);
  left: 350px;
  top: 84px;
}

.admin-btn {
  background-color: #2266bb;
  color: white;
  font-size: 12px;
  font-weight: 600;
  border-radius: 25px;
  color: white;
  padding: 8px 0;
  height: 34px;
  margin-right: 0px;
  cursor: pointer;
  &:disabled {
    cursor: default;
    background-position: 99% 0 !important;
    opacity: 0.5;
  }
}

.rp-header {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bold;
  padding: 30px 0px 15px;
  font-family: "Proxima SemiBold"
}

.header-right {
  display: flex;
}

.arrows {
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.edit-btn {
  width: 75px;
  padding: 4px 0;
  margin-right: 13px;
}

.delete-btn {
  width: 85px;
  padding: 4px 0;
}

.container {
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-right: 10px;
}

/* Hide the browser's default radio button */
.container input {
  display: none;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 13px;
  width: 13px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 1px solid #bfbfbf;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #2266bb4d;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2266bb;
}
</style>